<template>
  <div style="padding:0 0 16px 0">
    <Record v-if="record.id" :record="record" @cancel="record = {}" />
    <div v-else>
      <a-row>
        <div style="display: flex;align-items: center">
          <a-col :span="18">
              <div class="form-group-list">
                  <SelectField label="管网" id="type"
                               :modelValue="form.category" :options="typeList" style="width: 35%"
                               @update:modelValue="(value) => handleModelValueUpdate('category', value)"
                  />
                  <InputField style="width:30%;" label="编号" type="text" id="name"
                              :modelValue="form.code" placeholder="请输入编号" labelWidth="30%"
                              @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                  />
                  <a-space>
                      <ButtonField text="查询" @click="query" secondary/>
                      <ButtonField text="重置" primary @click="reset"/>
                  </a-space>
              </div>
          </a-col>

          <a-col :span="6">
            <div class="right" style="margin-top: 4px">
              <ButtonField text="新增" @click="setView('新增排口')" secondary />
            </div>
          </a-col>
        </div>
      </a-row>

      <div style="padding-bottom: 16px"></div>
        <Tablelist
                :showCheckbox="false"
                :list="list"
                :totalSize="totalSize"
                :totalPages="totalPages"
                :pageNum="pageNum"
                :pageSize="pageSize"
                :columns="tableColumns"
                @action="handleAction"
        >
            <template #template-category="{ item }">
                <DataDictFinder dictType="pipeType" :dictValue="item.category" iconType="text" />
            </template>
            <template #template-type="{ item }">
                <DataDictFinder dictType="wellType" :dictValue="item.type" />
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a @click="setRecord(item)">维保记录</a>
                    <a @click.stop="edit(item)">编辑</a>
                    <a class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>

      <div v-if="list.length === 0" style="padding-bottom: 16px"></div>
    </div>
  </div>
</template>
<script>
import store from "../mixins/store";
import { fetchList, del } from "@/api/assets/outlet";
import { mapGetters } from "vuex";

import Record from "./record.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import Tablelist from "@/components/water-affairs-style/table-list.vue";

export default {
  mixins: [store],

  components: {
      Tablelist,
      ButtonField, SelectField, InputField,
    Record,
  },

  data() {
    return {
      form: {},
      list: [],
      loading: false,
      totalSize: 1,
      totalPages: 1,
      pageNum: 1,
      pageSize: 10,
      record: {},
      tableColumns:[
          {
              key: 'code',
              title: '编号',
              field: 'code',
              infotype: 'text'
          },
          {
              key: 'category',
              title: '分类',
              field: 'category',
              infotype: 'template'
          },
          {
              key: 'elevation',
              title: '地面高程(m)',
              field: 'elevation',
              infotype: 'text'
          },
          {
              key: 'location',
              title: '所在位置',
              field: 'location',
              infotype: 'text'
          },
          {
              key: 'accessary',
              title: '附属物',
              field: 'accessary',
              infotype: 'text'
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template'
          }
      ]
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("pipeType");
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
      handleAction(actionInfo) {
          const { type,  id,item } = actionInfo;
          switch(type) {
              case 'edit':
                  this.edit(item);
                  break;
              case 'custom':
                  this.setRecord(item);
                  break;
              case 'delete':
                  this.deleteText(id);
                  break;
          }
      },
    getList() {
      this.loading = true;
      let { form } = this;

      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },

    edit(row) {
      this.select({
        ...row,
        _edit: true,
      });
      this.setView("修改排口");
    },

    select(row) {
      this.setSelectedWell({
        ...row,
        _change: true,
      });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除该排口吗？",
        onOk() {
          del({
            id: text.id,
            category: text.category,
          }).then(() => {
            that.getList();
            that.getRainOutletList();
          });
        },
      });
    },

    setRecord(text) {
      this.record = text;
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}
</style>